import { render, staticRenderFns } from "./ReviewMobileModal.vue?vue&type=template&id=3a45094b&scoped=true&"
import script from "./ReviewMobileModal.vue?vue&type=script&lang=js&"
export * from "./ReviewMobileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a45094b",
  null
  
)

export default component.exports